import DOMPurify from "dompurify";
import fetch from "isomorphic-fetch";

const util = {
  getApiUrl: function () {
    let uri = $("#hidApiUrl").val();
    if (!uri || uri.length === 0) {
      switch (window.location.hostname.toLowerCase().replace("www.", "")) {
        case "lcl.myteamcare.org":
          uri = "https://api.lclcentralstatesfunds.org";
          break;
        case "dev.myteamcare.org":
          uri = "https://api-dev.centralstatesfunds.org";
          break;
        case "qa.myteamcare.org":
          uri = "https://api-qa.centralstatesfunds.org";
          break;
        case "uat.myteamcare.org":
          uri = "https://api-uat.centralstatesfunds.org";
          break;
        case "crm.myteamcare.org":
          uri = "https://api-crm.centralstatesfunds.org";
          break;
        default:
          uri = "https://api.centralstatesfunds.org";
          break;
      }
    }
    return uri;
  },

  getGqlUrl: function () {
    return `${this.getApiUrl()}/gql`;
  },

  getGqlHeaders: function () {
    return {
      "Content-Type": "application/json",
      Authorization: `Bearer ${$("#hidToken").val()}`,
    };
  },

  getJsonOrThrow: function (res) {
    if (res.status !== 400 && res.status !== 200) {
      throw Error(res.status + " " + res.statusText);
    }
    return res.json();
  },

  getObjectFromGql: function (res, notation) {
    if (
      typeof res.ErrorRef !== "undefined" &&
      res.ErrorRef !== null &&
      res.ErrorRef.length > 0
    ) {
      let errorMessage = "";
      if (
        typeof res.SystemMessages !== "undefined" &&
        res.SystemMessages !== null &&
        res.SystemMessages.length > 0 &&
        typeof res.SystemMessages[0].Message !== "undefined" &&
        res.SystemMessages[0].Message !== null &&
        res.SystemMessages[0].Message.length > 0
      ) {
        errorMessage = res.SystemMessages[0].Message + " ";
      }
      throw Error(errorMessage + res.ErrorRef);
    } else {
      if (
        typeof notation !== "undefined" &&
        notation !== null &&
        notation.length > 0
      ) {
        return notation.split(".").reduce((o, i) => o[i], res);
      }
      return res;
    }
  },

  fetchData: function (query, notation, success, error) {
    const self = this;
    fetch(this.getGqlUrl(), {
      method: "POST",
      headers: this.getGqlHeaders(),
      body: JSON.stringify(query),
    })
      .then(function (res) {
        return self.getJsonOrThrow(res);
      })
      .then(function (res) {
        success(self.getObjectFromGql(res, notation));
      })
      .catch(function (err) {
        error(err);
      });
  },

  getLinkLoadingIcon: function () {
    return `
      <i class="icon inlineHeartIcon">
        <span class="inlineHeartIcon__inner">
          <svg class="heartAnimation" width="201" height="164" viewBox="0 0 201 164" xmlns="http://www.w3.org/2000/svg">
            <path class="heartAnimationPath" d="M47.176 6h-.013c-.512 0-.73.001-.987.005-.302.006-.555.015-.783.031l-.133.008A41.16 41.16 0 0 0 20.92 78.868l.234.194.213.216 75.647 76.747a3.4 3.4 0 0 0 4.818.032l60.36-59.5 16.587-16.344.236-.19a41.17 41.17 0 0 0-23.29-73.184 41.078 41.078 0 0 0-31.452 11.817l-24.056 23.57-4.2-4.267-19.415-19.725C68.787 10.386 58.191 5.976 47.176 6z" stroke="#EF4237" stroke-width="12" fill-rule="nonzero" fill="none"></path>
          </svg>
        </span>
      </i>`;
  },

  showCardErrorMessage: function (
    div,
    inline,
    message,
    dismissible,
    hidePanelSubAlert,
  ) {
    const error = `
      <div class="alert__icon">
        <i class="icon icon-report-problem-triangle"></i>
      </div>
      <div class="alert__text prose prose--small">
        ${
          message && message.length > 0
            ? message
            : '<p><strong>Our system is experiencing an error.</strong> Please try again or <a href="/contact-us">contact us</a>.</p>'
        }
      </div>`;
    if (inline) {
      div.append(`
        <div class="${
          hidePanelSubAlert ? "" : "panelSubAlert "
        } alert alert--inline alert--error fade show ${
          dismissible ? "alert-dismissible" : ""
        }" role="alert">
          ${error}
          ${
            dismissible
              ? '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><i class="icon icon-close"></i></button>'
              : ""
          }
        </div>
      `);
    } else {
      div.append(`
        <div class="overlayAlert">
          <div class="alert alert--error fade show ${
            dismissible ? "alert-dismissible" : ""
          }" role="alert">
            ${error}
            ${
              dismissible
                ? '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><i class="icon icon-close"></i></button>'
                : ""
            }
          </div>
          <div class="overlayAlert__fill"></div>
        </div>
      `);
    }
  },

  removeCardErrorMessage: function (div) {
    div.find(".alert--error").remove();
  },

  removeCardLoader: function (div, inline) {
    if (inline) {
      div.find(".inlineHeartAnimationWrap").hide();
    } else {
      div.find(".overlayAnimationWrap").hide();
    }
  },

  showCardLoader: function (div, inline) {
    if (inline) {
      div.find(".inlineHeartAnimationWrap").show();
    } else {
      div.find(".overlayAnimationWrap").show();
    }
  },

  removeCard: function (div) {
    div.parents(".panelsGroup__col").remove();
  },

  formatCurrency: function (val, addDollarSign, showDecimals, showCommas) {
    if (typeof val === "undefined" || val === null) {
      return "";
    }
    if (typeof showDecimals === "undefined" || showDecimals === null) {
      showDecimals = true;
    }
    if (typeof addDollarSign === "undefined" || addDollarSign === null) {
      addDollarSign = true;
    }
    if (typeof showCommas === "undefined" || showCommas === null) {
      showCommas = true;
    }
    if (typeof val === "string") {
      val = parseFloat(val);
    }
    const decimalPlace = showDecimals ? 2 : 0;
    return (
      (addDollarSign ? "$" : "") +
      val.toFixed(decimalPlace).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    );
  },

  getParameterByName: function (name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  },

  toTitleCase: function (str) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  },

  getProgressBarClass: function (percentage) {
    if (percentage <= 10) {
      return "progressBarLabel--position--start";
    } else if (percentage >= 90) {
      return "progressBarLabel--position--end";
    } else {
      return "progressBarLabel--position--middle";
    }
  },

  removeProgressBarClasses: function (div) {
    div.removeClass("progressBarLabel--position--start");
    div.removeClass("progressBarLabel--position--end");
    div.removeClass("progressBarLabel--position--middle");
  },

  helloSignId: function () {
    switch (window.location.hostname.toLowerCase().replace("www.", "")) {
      case "myteamcare.org":
        return "7166954dfb29e5d0022a9ab6f504f581";
      case "lcl.myteamcare.org":
        return "3bd7de004c16df864f7444434815dcbe";
      default:
        return "883c40e5e8988855aeb95cfac418d8a0";
    }
  },

  skipDomainVerification: function () {
    switch (window.location.hostname.toLowerCase().replace("www.", "")) {
      case "myteamcare.org":
      case "qa.myteamcare.org":
      case "uat.myteamcare.org":
      case "crm.myteamcare.org":
        return false;
      default:
        return true;
    }
  },

  helloSignDebugMode: function () {
    switch (window.location.hostname.toLowerCase().replace("www.", "")) {
      case "myteamcare.org":
        return false;
      default:
        return true;
    }
  },

  sanitizeHtml: function (val) {
    return DOMPurify.sanitize(
      val,
      val?.match(/target=/) ? { ADD_ATTR: ["target"] } : undefined,
    );
  },

  sanitizeString: function (str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace("(", "%28")
      .replace(")", "%29")
      .toLowerCase()
      .replace("script", "script type='javascript/blocked'");
    // For now just escaping 7 characters but if we need to escape more chars then we can use escape()
    // too in future for chars like !@#$%^&{}[]=:/,;?+\'"\\
  },

  formatPhone: function (val) {
    if (!val || !val.length) {
      return "";
    }
    const updatedVal = val.replace(/[^\d]/g, "");
    return updatedVal.replace(/1?(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
  },
};

export default util;
